import * as yup from "yup";

export const BrandSocialSchema = yup.object().shape({
	instagram: yup.string().max(500, "Max  length 500 characters").nullable(), //.required("instagram handle is required"),
	linkedin: yup.string().max(500, "Max  length 500 characters").nullable(), //.required("linkedin handle is required"),
	discord: yup.string().max(500, "Max  length 500 characters").nullable(), //.required("discord handle is required"),
	twitter: yup.string().max(500, "Max  length 500 characters").nullable(),//.required("twitter handle is required"),

});
